module.exports = __webpack_public_path__ + "img/max-leumi-stacked.78201379.svg";